import React from 'react'
import {
  Show,
  TextField,
  DateField,
  ArrayField,
  Datagrid,
  BooleanField,
} from 'react-admin';
import { Box } from '@mui/material';
import NestedReferenceField from '../../components/NestedReferenceField';

const TeamShow = (props) => {
  return (
    <Show {...props} title="Team Details">
      <Box display="flex" flexDirection="column" gap={2} padding={2}>
        <TextField source="id" label="ID" />
        <TextField source="name" />
        <TextField source="description" />
        <NestedReferenceField source="organisation" labelField="name" resource="organisations" label="Organisation" />
        <TextField source="confidentiality_policy" label="Confidentiality" />
        <TextField source="membership_type_to_accept_requests" label="Membership type to accept requests" />
        <DateField source="creation_date" label="Created at" showTime />
        <DateField source="update_date" label="Updated at" showTime />

        <ArrayField source="user_in_teams">
          <Datagrid bulkActionButtons={false}>
            <NestedReferenceField source="user" labelField="email" resource="users" label="User" />
            <BooleanField source="accepted" />
          </Datagrid>
        </ArrayField>
      </Box>
    </Show>
  );
};

export default TeamShow;
